var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screens w-full relative overflow-hiddens",attrs:{"id":"root"}},[_c('router-view',{attrs:{"name":"layout"}},[_c('div',{staticClass:"content"},[_c('router-view',{key:_vm.$route.fullPath,attrs:{"name":"content"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }